/**
 * Language filter for the /community-library grid.
 *
 * Values are the library language tags that the backend's
 * `communityLibraries(language:)` accepts. The backend matches
 * `youtube_downloads.language` by base subtag, so `en-US` also finds
 * downloads stored as `en`. Videos whose language was never detected
 * (`auto`) only appear under "all languages".
 *
 * Español is deliberately not offered: the community pool holds no Spanish
 * videos yet, so the option would always come back empty. The backend already
 * accepts `es-ES`; adding it here (plus its label) is all it takes.
 */
export const COMMUNITY_LANGUAGE_FILTERS = ['pt-BR', 'en-US'] as const;

export type CommunityLanguageFilter = (typeof COMMUNITY_LANGUAGE_FILTERS)[number];

/** Select value for "all languages" (Radix Select disallows an empty value). */
export const ALL_COMMUNITY_LANGUAGES = 'all';

export function parseCommunityLanguageFilter(value: string): CommunityLanguageFilter | null {
  return (COMMUNITY_LANGUAGE_FILTERS as readonly string[]).includes(value)
    ? (value as CommunityLanguageFilter)
    : null;
}
